import { Box, Divider, Typography } from "@mui/material";
import React from "react";

export default function TwoColumn({
  leftColumnView,
  spacer = null,
  RightColumnView,
}) {
  return (
    <Box sx={{ py: 1.2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="body2" color="text.secondary" fontWeight={500}>
          {leftColumnView}
        </Typography>
        <Typography variant="body2" fontWeight={600}>
          {RightColumnView || "—"}
        </Typography>
      </Box>
      <Divider sx={{ mt: 1.2 }} />
    </Box>
  );
}
